import { render, staticRenderFns } from "./ShapeLinksList.vue?vue&type=template&id=624b2a0a&"
import script from "./ShapeLinksList.vue?vue&type=script&lang=js&"
export * from "./ShapeLinksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports